import { z } from "zod";

export const GetDeploymentChatroomPathVarsSchema = z.object({
  id: z.string().uuid()
});

/**
 * No field: the session id travels in the `x-session-id` header, never in the
 * query string, because it is the capability to resume the conversation and a
 * query string is written into every access log on the way to the handler.
 */
export const GetDeploymentChatroomQuerySchema = z.object({});

export const GetDeploymentChatroomResponseSchema = z.object({
  chatroom: z.object({
    id: z.string().uuid(),
    status: z.string().optional(),
    type: z.string().optional(),
    topic: z.string().nullable().optional()
  }),
  isNew: z.boolean(),
  messages: z
    .array(
      z.object({
        id: z.string().uuid(),
        content: z.any(),
        type: z.string(),
        createdAt: z.string().datetime()
      })
    )
    .optional()
});

export type GetDeploymentChatroomPathVars = z.infer<typeof GetDeploymentChatroomPathVarsSchema>;
export type GetDeploymentChatroomQuery = z.infer<typeof GetDeploymentChatroomQuerySchema>;
export type GetDeploymentChatroomResponse = z.infer<typeof GetDeploymentChatroomResponseSchema>;
